import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReportModal from './ReportModal';
import Clock from 'react-clock';
import 'react-clock/dist/Clock.css';
import axios from 'axios';
import { baseURL } from '../../utilits/config';
import {addComments, getCommentByTaskID} from "../../api/Coments";
import {getTaskBYTaskID} from "../../api/task";

function TaskReport() {
  const [date, setDate] = useState(new Date());
  const {id} = useParams();
  const [taskID, setTaskID] = useState(id);
  const [taskData, setTaskData] = useState({});
  const [loading, setLoading] = useState(false);
  const [assignUser, setAssignUsers] = useState([]);
  const [subTask, setSubTask] = useState([]);
  const [taskDate, setTaskDate] = useState("");
  const [commentData, setCommentData] = useState([]);

     const getDetails = () =>{
     var config = {
        method : "get",
        url : baseURL + "/getTaskBYid?id=" + id,
        headers : {},
     };
     axios(config)
         .then((result) =>{
            setTaskData(result.data.result[0]);
            setTaskDate(result.data.result[0].delivary_date)
         })
         .catch((error) =>{
           console.log(error);
         })
     }

     const getAssignUsers = () =>{
           var config = {
              method : "get",
              url: baseURL + "/getTaskAssignUsers?id=" + id,
              headers : {},
           };

           axios(config)
               .then((result)=>{
                  setAssignUsers(result.data.result);
               })
               .catch((error) =>{
                  console.lo(error);
               })
     }
     
     const getSubTasks = () =>{
        var config = {
           method: "get",
           url : baseURL + "/getTaskAssign?id="+id,
           headers : {},
        };

        axios(config)
            .then((result) =>{
               setSubTask(result.data.result); 
            })
            .catch((error)=>{
                console.log(error);
            })
     }

     const getComments = () =>{
         getCommentByTaskID(id, (result) =>{
             if(result.ok === 1){
                setCommentData(result.result);
             }
         })
     }


     
  
     
  
    
  
  const [comment_name, setComment_name] = useState("");
  function handleComments(e){
      setComment_name(e.target.value);
  }
  
   function handleCommentSubmit(e){
      e.preventDefault();
        if(comment_name.length < 1){
            return alert("Comment field should not be empty!");
        }
        const date = new Date();
        const todayDate = date.getDay() + "-" + date.getMonth() + "-"+ date.getFullYear();

          const commentData = {
              taskID,
              comment_name,
              todayDate,
          }
         addComments(commentData, (result) =>{
            if(result.ok == 1){
               console.log(result);
               return alert(result.message);
            }
           if(result.ok === 0){
            console.log(result);
            return alert("Server error 404");
           }
         })
   }



  useEffect(() => {
    getDetails();
    getAssignUsers();
    getSubTasks();
    getComments();
    const interval = setInterval(() => {
      setDate(new Date());
    }, 3000);

    return () => {
      clearInterval(interval);
    };
    
    
  }, [taskData]);
  
    return ( 
        <div class="container mt-4">
        <div className='row justify-content-center'>
          <div className='row'>
              <div className='col md-6'>
                
                </div> 
              <div className='col md-6'>
                {/* <button className='btn btn-primary btn-sm float-right' onClick={() =>{showModal()}}>Add Report</button> */}
                </div> 
            </div> 
        </div>
            
          

            <div className='row justify-content-center'>
            <div className="row">
                   <div className='card' style={{height : 210}}>
                    <div className='card-body'>
                    <center><Clock value={date} size={130} /></center>
                    <center><h5>Expire Date : {taskData.delivary_date}<b></b></h5></center>
                    <center><h6>Service Name : {taskData.service_name}</h6></center>
                    </div>
                   </div>
                 </div>

                 <div className="row mt-4">
                   <div className='card' style={{height : 320}}>
                    <div className='card-body'>
                    <h4>Task Details</h4>
                    <table className='table table-hover'>
                    <tbody>
                    <tr>
                      <td><b>Task No: #{taskData.taskID}</b></td>
                      <td></td>
                     </tr>
                     <tr>
                      <td><b>Tasks Title: {taskData.service_name}</b></td>
                      <td></td>
                     </tr>
                     <tr>
                      <td><b>Piority: {taskData.piority}</b> </td>
                      <td></td>
                     </tr>
                     <tr>
                      <td><b>Client Name: {taskData.client_name}</b> </td>
                      <td></td>
                     </tr>
                     <tr>
                      <td><b>Status: {taskData.status}</b></td>
                      <td></td>
                     </tr>
                     <tr>
                      <td><b>Due Date: {taskData.delivary_date}</b></td>
                      <td></td>
                     </tr>
                    </tbody>
                    </table>
                    </div>
                   </div>
                 </div>


                 <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>Assign To</h4>
                      <table className="table table-hover">
                        <tbody>
                         { assignUser.map((item, index) =>(
                           <tr>
                           <td>
                            <div className='row'>
                             <div className='col md-6'> <div style={{height:60, width:60, borderRadius:30, backgroundColor:"whitesmoke", justifyContent:"center", alignItems:"center"}}><i style={{fontSize:24}} className='fa fa-user ml-3 mt-4'></i></div></div>
                             <div className='col md-6'>
                               <h5>{item.userName}</h5>
                               <p>Accounting & Auditing</p>
                             </div>
                            </div>
                           </td>
                         </tr>
                         ))}
                         
                        </tbody>
                      </table>
                    </div>
                   </div>
                 </div>


                 <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>Attachments</h4>
                      <table className="table table-hover">
                        <tbody>
                          {/* <tr>
                            <td>
                             <div className='row'>
                              <div className='col md-4'> <div style={{height:60, width:60, borderRadius:30, backgroundColor:"whitesmoke", justifyContent:"center", alignItems:"center"}}><i style={{fontSize:24}} className='fa fa-folder ml-3 mt-4'></i></div></div>
                              <div className='col md-4'>
                                <h5>App Pages.zip</h5>
                                <p>2.24 mb</p>
                              </div>
                              <div className='col md-4'>
                            <a href='#'>  <i style={{fontSize:18}} className='fa fa-download ml-3 mt-4'></i></a>
                              </div>
                             </div>
                            </td>
                          </tr> */}

                          <center style={{color: "red", fontWeight:"bold"}}>No Attachments Found!</center>
                        
                        </tbody>
                      </table>
                    </div>
                   </div>
                 </div>

                 <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>Collaboration</h4>
                      <table className="table table-hover">
                        <tbody>
                          {/* <tr>
                            <td>
                             <div className='row'>
                              <div className='col md-6'> <div style={{height:60, width:60, borderRadius:30, backgroundColor:"whitesmoke", justifyContent:"center", alignItems:"center"}}><i style={{fontSize:24}} className='fa fa-user ml-3 mt-4'></i></div></div>
                              <div className='col md-6'>
                                <h5>allangrayson@gmail.com</h5>
                                <p>Softwere Developer</p>
                              </div>
                             </div>
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                      <center style={{color: "red", fontWeight:"bold"}}>No Collaboration  Found!</center>
                    </div>
                   </div>
                 </div>


                 <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>SUb TASK (ASSIGNMENTs)</h4>
                     <h6>Description :</h6>
                    <p>{taskData.desc_description}</p>
                     
                             <div className='row'>
                            <div className='col md-12'>

                               <table className='table table-hover'>
                                 <thead >
                                  <tr>
                                    <th>#</th>
                                    <th>Sub-Task name</th>
                                    <th>Point</th>
                                    <th>duration hrs</th>
                                    <th>Progres</th>
                                    <th></th>
                                  </tr>
                                 </thead>
                                 <tbody>
                                 {subTask.length === 0 ? (
                                       <center style={{color: "red", fontWeight:"bold"}}>No Sub Assignment  Found!</center>
                                 ) : (
                                  <>
                                  {subTask.map((item, index)=>(
                                    <tr key={index}>
                                    <td><input type="checkbox" /></td>
                                    <td>{item.assign_name}</td>
                                    <td>{item.point}</td>
                                    <td>Hrs {item.duration} {item.duration == 8 ?(<span className='badge badge-danger m-3'>1 day</span>) : item.duration > 8 ?(<span className='badge badge-danger m-3'>1 Day and {item.duration - 8} Hrs</span>) : null }
                                    <br></br>
                                     <p>{taskDate}</p>
                                    </td>
                                    <td>
                                    {item.status === "Pending" ? (
                                       <> <span class="badge text-bg-info">{item.status}</span> <br></br> <input type="range" value="0"/></>
                                     ) : item.status === "Ongoing" ? (
                                       <> <span class="badge text-bg-warning">{item.status}</span> <br></br> <input type="range" value="50"/></>
                                     ) : item.status === "Complete" ? (
                                       <><span class="badge text-bg-success">{item.status}</span> <br></br> <input type="range" value="100"/></>
                                     ) : null }
                                    </td>
                                    <td><a href='#' className='btn btn-success'>View</a></td>
                                  </tr>
                                  ))}
                                  </>
                                 )}
                                 </tbody>
                               </table>
                            </div>
                             </div>
                    </div>
                   </div>
                 </div>


                 <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>Report</h4>
                     
                    <div className="table-responsive table-card">
                                                <table className="table align-middle mb-0">
                                                    <thead className="table-light text-muted">
                                                        <tr>
                                                            <th scope="col">Client</th>
                                                            <th scope="col">Assignment</th>
                                                            <th scope="col">Final Delivary Report</th>
                                                            <th scope="col">Activities</th>
                                                            <th scope="col">% Completion</th>
                                                            <th scope="col">Deadline Date</th>
                                                            <th scope="col">Officer</th>
                                                            <th scope="col">Challenge & <br></br> solution</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* <tr>
                                                            <th scope="row">
                                                                <div className="d-flex align-items-center">
                                                                    <img src="assets/images/users/avatar-8.jpg" alt="" className="rounded-circle avatar-xxs"/>
                                                                    <div className="flex-grow-1 ms-2">
                                                                        <a href="pages-profile.html" className="fw-medium text-body">Thomas Taylor</a>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <td>02 Jan, 2022</td>
                                                            <td>3 hrs 12 min</td>
                                                            <td>05 min</td>
                                                            <td>Apps Pages</td>
                                                            <td>3 hrs 12 min</td>
                                                            <td>05 min</td>
                                                            <td>Apps Pages</td>
                                                        </tr> */}
                                                        <center style={{color: "red", fontWeight:"bold"}}>No Report Uploaded  Found!</center>
                                                    </tbody>
                                                </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>


                                      <div className="row mt-4 ">
                   <div className='card' style={{height : "auto"}}>
                    <div className='card-body'>
                    <h4>Comments</h4>
                             <div className='row'>
                            <div className='col md-12'>
                              <h6>(Comments - {commentData.length})</h6>

                              {commentData.map((item)=>(
                                  <ul>
                                  <li style={{fontSize:24}}><i>"{item.comment_name}"</i></li>
                                </ul>
                              ))}

                              <form method='POST'>
                              <textarea className='form-control' name='comment_name' onChange={handleComments}  placeholder='Leave a comment'></textarea>
                               <div className='form-group'>
                               <button className='btn btn-success btn-sm mt-3' onClick={handleCommentSubmit}>Post Comments</button>
                               </div>
                              </form>
                            </div>
                             </div>
                    </div>
                   </div>
                 </div>

            </div>


</div>
     );
}

export default TaskReport;